
export class GetUsersByIdsRequestDto {
  userIds?: string[];
}
